import React, {PropTypes} from 'react';
import Link from '../../routing/components/Link';

const TocArticleEl = props => {
  let {articles, level} = props;
  return (
    <ul className={`structure-toc-level-${level + 1} structure-toc-articles`}>{
      articles.map(art => {
        return (<li key={art.id}><Link url={art.url}><span dangerouslySetInnerHTML={{__html: art.body}}/></Link></li>);
      })}
    </ul>
  );
};

TocArticleEl.propTypes = {
  articles: PropTypes.array.isRequired,
  level: PropTypes.number.isRequired
};

export default TocArticleEl;



/** WEBPACK FOOTER **
 ** ./src/modules/structures/components/TocArticleEl.js
 **/